<template>
  <div
    role="alert"
    :class="componentClass"
    :style="componentStyle"
    :size="size"
  >
    <template v-if="hasIcon">
      <wa-question-mark-block
        v-if="iconName === 'faBlockQuestion'"
        :block-size="iconSize"
        class="decorative"
      />
      <font-awesome-icon
        v-else
        :icon="$v6[iconStyle][iconName]"
        :icon-size="iconSize"
        :spin="isIconSpinning"
        class="decorative"
      />
    </template>

    <slot name="title">
      <h3
        v-if="hasTitle"
        class="h5"
      >
        {{ title }}
      </h3>
    </slot>

    <slot name="content">
      <p
        v-if="hasContent"
        style="--paragraph-margin-bottom: 0"
      >
        {{ content }}
      </p>
    </slot>

    <button
      v-if="isDismissable"
      type="button"
      aria-label="Close"
      data-balloon-pos="left"
      class="close"
      @click.prevent="$emit('close')"
    >
      <font-awesome-icon :icon="$v6.duotone.faCircleXmark" />
    </button>
  </div>
</template>
<script>
  export default {
    name: 'Message',

    props: {
      content: {
        type: String,
        default: null
      },
      customStyle: {
        type: Object,
        default: () => {}
      },
      hasBorder: {
        type: Boolean,
        default: false
      },
      iconName: {
        type: String,
        default: null
      },
      iconStyle: {
        type: String,
        default: 'solid'
      },
      iconSize: {
        type: String,
        default: null
      },
      isDismissable: {
        type: Boolean,
        default: false
      },
      isIconSpinning: {
        type: Boolean,
        default: false
      },
      size: {
        type: String,
        default: null
      },
      title: {
        type: String,
        default: null
      },
      theme: {
        type: String,
        default: null
      },
      type: {
        type: String,
        default: null
      }
    },

    computed: {
      hasContent() {
        return this.content
      },
      hasIcon() {
        return this.iconName
      },
      hasTitle() {
        return this.title
      },
      isDanger() {
        return this.theme === 'danger' || this.theme === 'red'
      },
      isDocs() {
        return this.theme === 'docs'
      },
      isInfo() {
        return this.theme === 'info' || this.theme === 'blue'
      },
      isSuccess() {
        return this.theme === 'success' || this.theme === 'teal'
      },
      isWarning() {
        return this.theme === 'warning' || this.theme === 'yellow'
      },
      isFlash() {
        return this.type === 'flash'
      },
      componentClass() {
        return [`message ${this.size} ${this.theme}`, { 'with-border': this.hasBorder }, { 'with-close': this.isDismissable }, { 'with-icon': this.hasIcon }]
      },
      componentStyle() {
        let style = {}

        if (this.isFlash) {
          style['--message-margin'] = '0 0 var(--spacing-2xl) 0'
        }

        return {
          ...style,
          ...this.customStyle
        }
      }
    }
  }
</script>
